<div class="ta-counter">
  <p>{{getValue.length}}
    @if (maxLength > 0) {
      <span>/{{maxLength}}</span>
    }
  </p>
</div>

@if (instructionTextPresent) {
  <div class="instruction-container">
    <span class="instruction-text">{{instructionText}}</span>
  </div>
}

<textarea class="sem-text-area" (input)="onTextChange($event.target.value)" [(ngModel)]="value"
[semSpellcheck]="spellCheck" [scLanguage]="spellCheckLanguage" [scClassType]="spellCheckClassType" [scField]="spellCheckField"
[disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true" [minlength]="minLength" [maxlength]="maxLength" [ngClass]="{ 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }"></textarea>

<!-- Record translations. Renders nothing unless the feature is on AND this field is declared
     translatable, so every other form is untouched. -->
<sem-translation-pills [fieldName]="getAttribute('name')" [multiline]="true"
  [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true"></sem-translation-pills>
